// extracted by mini-css-extract-plugin
export var container = "_26-0";
export var disabled = "_26-4";
export var fullWidth = "_26-3";
export var lined = "_26-1";
export var selected = "_26-5";
export var tab = "_26-2";